import { Suspense } from "react";
const IsomorphicSuspense = typeof window !== "undefined" ? Suspense : _ref => {
  let {
    fallback
  } = _ref;
  return fallback;
};
export { IsomorphicSuspense as default };